// extracted by mini-css-extract-plugin
export default {"form":"Form_form__cyH1C","title":"Form_title__XV9Gj","field":"Form_field__Piy96","button":"Form_button__SUcV0"};